/**
 * This function does nothing. It appears that sanitization is not
 * necessary for Angular (since XSS protection is built into Angular).
 *
 * The bigger concern is to prevent JS code injection which this doesn't
 * help with. sanitize-html was removed because it does not appear to
 * help, and version >v1 can't be used without some special webpack
 * settings. Finally, versions <2.?.? have a serious security vunerabilty
 * so if anything it appears to increase our attack surface.
 *
 * https://snyk.io/blog/5-ways-to-prevent-code-injection-in-javascript-and-node-js/
 *
 * @param value
 * @returns
 */
export function sanitizeString(value: string | undefined): string | undefined {
  return value;
}
